__turbopack_context__.v({
  "amount": "UnpaidOrderNotice-module__rvaRPW__amount",
  "badge": "UnpaidOrderNotice-module__rvaRPW__badge",
  "closeButton": "UnpaidOrderNotice-module__rvaRPW__closeButton",
  "description": "UnpaidOrderNotice-module__rvaRPW__description",
  "floatingButton": "UnpaidOrderNotice-module__rvaRPW__floatingButton",
  "modalBox": "UnpaidOrderNotice-module__rvaRPW__modalBox",
  "modalFooter": "UnpaidOrderNotice-module__rvaRPW__modalFooter",
  "modalHeader": "UnpaidOrderNotice-module__rvaRPW__modalHeader",
  "modalOverlay": "UnpaidOrderNotice-module__rvaRPW__modalOverlay",
  "modalTitle": "UnpaidOrderNotice-module__rvaRPW__modalTitle",
  "orderButton": "UnpaidOrderNotice-module__rvaRPW__orderButton",
  "orderDate": "UnpaidOrderNotice-module__rvaRPW__orderDate",
  "orderItem": "UnpaidOrderNotice-module__rvaRPW__orderItem",
  "orderList": "UnpaidOrderNotice-module__rvaRPW__orderList",
  "orderNumber": "UnpaidOrderNotice-module__rvaRPW__orderNumber",
  "payNow": "UnpaidOrderNotice-module__rvaRPW__payNow",
  "right": "UnpaidOrderNotice-module__rvaRPW__right",
});
